const ITEMS = [
  "Filters",
  "Cranes",
  "Excavators",
  "Backhoe Loaders",
  "Haul Trucks",
  "Hydraulics",
  "Spare Parts",
  "Drills",
  "Conveyors",
  "Engines",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="border-y border-border bg-secondary py-4 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-sm uppercase tracking-[0.2em] text-muted-foreground">
            <span className="px-8">{item}</span>
            <span className="text-primary">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
